import { toast } from 'react-toastify';
export default function ErrorToast(message) {
    toast.error(message, {
        className: 'error-toast',
        position: toast.POSITION.TOP_CENTER,
        autoClose: 10000,
        theme: 'colored',
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
}
//# sourceMappingURL=ErrorToast.js.map